import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from '@mui/material';

import MultipleChoiceCheckbox from './MultipleChoiceCheckbox';
import RowContainerList from './RowContainerList';
import { createArray } from '../../../utilities/arrayHelper';

const MultipleChoiceOptions = ({
  options,
  startCase,
  numCases,
  onChange,
  isChecked,
  renderCustomItem,
  disabled,
}) => (
  <div>
    {
      options.map((option, _index) => (
        <RowContainerList
          key={option.uuid}
          option={option}
          startCase={startCase}
          index={_index}
        >
          {
            createArray(numCases).map((_, sampleIndex) => {
              const key = `${option.uuid}-${sampleIndex}`;
              return (
                <Tooltip key={key} title={`[P${sampleIndex + 1}] ${option.text}`}>
                  <li
                    className="mr2 basis-100 w2 flex flex-wrap justify-center content-center"
                    style={{ flexBasis: '100%' }}
                  >
                    <MultipleChoiceCheckbox
                      value={option.uuid}
                      name={`${startCase}-${sampleIndex}-checkbox`}
                      checked={isChecked(sampleIndex, option.uuid)}
                      onChange={
                        (ev) => onChange(sampleIndex, option.uuid, ev.target.checked)
                      }
                      disabled={disabled}
                    />
                    {
                      renderCustomItem
                      && renderCustomItem(option.uuid, sampleIndex)
                    }
                  </li>
                </Tooltip>
              );
            })
          }
        </RowContainerList>
      ))
    }
  </div>
);

export default MultipleChoiceOptions;

MultipleChoiceOptions.defaultProps = {
  options: [],
  startCase: undefined,
  renderCustomItem: undefined,
  disabled: false,
};

MultipleChoiceOptions.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({
    uuid: PropTypes.string,
  })),
  startCase: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  isChecked: PropTypes.func.isRequired,
  numCases: PropTypes.number.isRequired,
  renderCustomItem: PropTypes.func,
  disabled: PropTypes.bool,
};
